import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Association from "@/pages/Association";
import Pole from "@/pages/Pole";
import Cours from "@/pages/Cours";
import Planning from "@/pages/Planning";
import Tarifs from "@/pages/Tarifs";
import Equipe from "@/pages/Equipe";
import Evenements from "@/pages/Evenements";
import Galerie from "@/pages/Galerie";
import Lieux from "@/pages/Lieux";
import { INSCRIPTIONS_URL } from "@/lib/data";

function InscriptionRedirect() {
  React.useEffect(() => { window.location.replace(INSCRIPTIONS_URL); }, []);
  return null;
}
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import LegalPage from "@/pages/LegalPage";
import { Toaster } from "sonner";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/association" element={<Association />} />
            <Route path="/poles/:slug" element={<Pole />} />
            <Route path="/cours" element={<Cours />} />
            <Route path="/planning" element={<Planning />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/evenements" element={<Evenements />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/lieux" element={<Lieux />} />
            <Route path="/inscription" element={<InscriptionRedirect />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/mentions-legales" element={<LegalPage kind="mentions" />} />
            <Route path="/confidentialite" element={<LegalPage kind="privacy" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}
